import { z } from 'zod';

const VegetationTypeDef = ['Forest', 'Open Bush', 'Heavy Treed', 'Wild Grass'] as const;

export const allVegetationTypes = [...VegetationTypeDef];

export type VegetationType = (typeof VegetationTypeDef)[number];

export const vegetationTypeSchema = z.enum(VegetationTypeDef);
